<template>
  <div>
    <ul class="list-group">
      <li class="list-group-item" @click="addItem(conditions, showHideFieldPattern)"><i class="fa fa-eye-slash"></i> Add Show / Hide field</li>
      <li class="list-group-item" @click="addItem(validationConditions, toggleRequiredPattern)"><i class="fa fa-check-circle"></i> Enable / Disable Required Field</li>
      <li class="list-group-item" @click="addItem(updateConditions, updateFieldConditionPattern)"><i class="fa fa-check-square-o"></i> Update Field</li>
      <li class="list-group-item" @click="addItem(hideValues, hideValuePattern)"><i class="fa fa-eye-slash"></i> Add Hide Value</li>
      <li class="list-group-item" @click="addItem(calculations, calcPattern)"><i class="fa fa-calculator"></i> Add Calculate field</li>
    </ul>

    <div class="section-title">Conditions</div>

    <ul class="list-group">
      <show-hide-condition-constructor
        v-for="(item, index) in conditions"
        :key="'list-group-item-' + index"
        :conditions="conditions"
        :item="item"
        :index="index"
        :schema="schema"
        :flat-schema="flatSchema"
        :remove-obj="removeObj"
      />
    </ul>

    <ul class="list-group">
      <li v-for="(item, index) in validationConditions" :key="'list-group-item-' + index"
          class="list-group-item">
        <i aria-hidden="true" class="fa fa-trash pull-right"
           @click="removeObj(validationConditions, index)"></i>
        <collapse :selected="false">
          <div class="collapsible-header" slot="collapsible-header">
            {{ item.name }}
          </div>
          <div class="collapsible-body" slot="collapsible-body">
            <div class="form-group">
              <label>Name</label>
              <input type="text" class="form-control" v-model="item.name">
            </div>
            <div class="form-group">
              <label>If</label>
              <select class="form-control" v-model="item.field">
                <option v-for="(form, index) in schema" :value="form.name"
                        :key="'cond-key-' + index"
                        v-if="!['text-entry', 'accordion', 'divider', 'row' ].includes(form.type)">
                  {{ form.description }}
                </option>
                <optgroup v-for="form in schema"
                          v-if="['accordion'].includes(form.type)"
                          :label="form.description">
                  <option v-for="field in form.values" :value="field.name"
                          v-if="!['text-entry', 'divider', 'row' ].includes(field.type)">
                    {{ field.description }}
                  </option>
                </optgroup>
              </select>
            </div>

            <div class="form-group">
              <label>State</label>
              <select class="form-control" v-model="item.state">
                <option value="equalTo">Is equal to</option>
                <option value="notEqualTo">Is not equal to</option>
              </select>
            </div>
            <div class="form-group">
              <label>Value</label>
              <input type="date" class="form-control" v-model="item.value"
                     v-if="item.field && item.field.startsWith('date')">
              <input type="text" class="form-control" v-model="item.value"
                     v-else>
            </div>

            <div class="clearfix"></div>
            <div class="form-group">
              <label>Do</label>
              <select class="form-control" v-model="item.action">
                <option value="setRequired">Enable Required Field</option>
                <option value="setNotRequired">Disable Required Field</option>
              </select>
            </div>
            <div class="form-group">
              <label>Field</label>
              <select class="form-control" v-model="item.targetField">
                <option v-for="(form, index) in schema" :value="form.name"
                        :key="'show-field-' + index"
                        v-if="![ 'accordion'].includes(form.type)">
                  <span v-if="'text-entry' !== form.type">{{ form.description }}</span><span
                  v-else="">{{ form.label }}</span></option>
                <optgroup v-for="form in schema"
                          v-if="['accordion'].includes(form.type)"
                          :label="form.description">
                  <option v-for="field in form.values" :value="field.name"
                          v-if="![ 'divider', 'row' ].includes(field.type)">{{ field.description }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div class="clearfix"></div>
          </div>
        </collapse>
      </li>
    </ul>

    <ul class="list-group">
      <li v-for="(item, index) in hideValues" :key="'list-group-item-' + index"
          class="list-group-item">
        <i aria-hidden="true" class="fa fa-trash pull-right"
           @click="removeObj(hideValues, index)"></i>
        <collapse :selected="false">
          <div class="collapsible-header" slot="collapsible-header">
            {{ item.name }}
          </div>
          <div class="collapsible-body" slot="collapsible-body">
            <div class="form-group">
              <label>Name</label>
              <input type="text" class="form-control" v-model="item.name">
            </div>
            <div class="states">
              <div class="form-group">
                <label>Select field</label>
                <select class="form-control" v-model="item.field">
                  <option v-for="(form, index) in schema" :value="form.name"
                          :key="'show-field-' + index"
                          v-if="[ 'checkbox-group', 'radio-group', 'select', 'rating'].includes(form.type)">
                    <span>{{ form.description }}</span>
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Do</label>
                <select class="form-control" v-model="item.action">
                  <option value="0">Hide</option>
                </select>
              </div>
              <div class="form-group">
                <label>Value</label>
                <input type="date" class="form-control" v-model="item.value"
                       v-if="item.field && item.field.startsWith('date')">
                <input type="text" class="form-control" v-model="item.value" v-else>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </collapse>
      </li>
    </ul>

    <ul class="list-group">
      <update-field-condition-constructor v-for="(item, index) in updateConditions"
                                          :key="'list-group-item-' + index"
                                          :update-conditions="updateConditions"
                                          :item="item"
                                          :index="index"
                                          :schema="schema"
                                          :flat-schema="flatSchema"
                                          :remove-obj="removeObj"/>
    </ul>

    <ul class="list-group">

      <li v-for="(item, index) in calculations" :key="'cond-' + index"
          class="list-group-item">
        <i aria-hidden="true" class="fa fa-trash pull-right"
           @click="removeObj(calculations, index)"></i>
        <collapse :selected="false">
          <div class="collapsible-header" slot="collapsible-header">
            {{ item.name }}
          </div>
          <div class="collapsible-body" slot="collapsible-body">
            <div class="form-group">
              <label>Name</label>
              <input type="text" class="form-control" v-model="item.name">
            </div>
            <hr>
            <div v-for="(question, index) in item.questions">
              <i aria-hidden="true" class="fa fa-trash pull-right"
                 @click="removeObj(item.questions, index)"
                 v-if="item.questions.length > 1"></i>
              <div class="form-group">
                <label>Question</label>
                <select class="form-control" v-model="question.field">
                  <option value="custom-value">Custom Value</option>
                  <option v-for="form in schema" :value="form.name"
                          v-if="['number', 'rating', 'date', 'currency','radio-group', 'shared-field'].includes(form.type)">
                    {{ form.description }}
                  </option>
                  <optgroup v-for="form in schema"
                            v-if="['accordion'].includes(form.type)"
                            :label="form.description">
                    <option v-for="field in form.values" :value="field.name"
                            v-if="['number', 'rating', 'date', 'currency', 'shared-field'].includes(field.type)">
                      {{ field.description }}
                    </option>
                  </optgroup>
                </select>
              </div>
              <div class="form-group" v-if="question.field === 'custom-value'">
                <label>Value</label>
                <input class="form-control" v-model="question.value">
              </div>
              <div class="form-group">
                <label>Select Calculation</label>
                <select class="form-control" v-model="question.calculation"
                        v-if="!isFieldDateDisplayType(question.field, schema)">
                  <option value="1">(+) Added to</option>
                  <option value="2">(-) Subtracted by</option>
                  <option value="3">(*) Multiplied by</option>
                  <option value="4">(/) Divided by</option>
                  <option value="5">(%) Percentage of</option>
                  <option value="6">(=) Equals</option>
                </select>
                <select class="form-control" v-model="question.calculation"
                        v-if="isFieldDateDisplayType(question.field, schema)">
                  <option value="1">(+) Added to (years)</option>
                  <option value="2">(-) Subtracted by (years)</option>
                  <option value="6">(=) Equals</option>
                  <option value="11">(+) Added to (days)</option>
                  <option value="12">(-) Subtracted by (days)</option>
                </select>
              </div>
              <hr/>
            </div>
            <div class="form-group">
              <label>Display results in</label>
              <select class="form-control" v-model="item.displayIn">
                <option v-for="form in schema" :value="form.name"
                        v-if="['number', 'rating', 'date', 'currency', 'radio-group','shared-field'].includes(form.type)">
                  {{ form.description }}
                </option>
                <optgroup v-for="form in schema"
                          v-if="['accordion'].includes(form.type)"
                          :label="form.description">
                  <option v-for="field in form.values" :value="field.name"
                          v-if="['number', 'rating', 'date', 'currency'].includes(field.type)">
                    {{ field.description }}
                  </option>
                </optgroup>
              </select>
            </div>
            <button class="btn green pull-right add-cond"
                    @click="addItem(item.questions, calcPattern.questions[0])">Add
            </button>
            <div class="clearfix"></div>
          </div>
        </collapse>
      </li>
    </ul>

  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

import UpdateFieldConditionConstructor from "./conditions/UpdateFieldConditionConstructor";
import ShowHideConditionConstructor from "./conditions/ShowHideConditionConstructor";
import {isFieldDateDisplayType} from "../../utils/functions";
import Collapse from '@/components/Collapse';
import {showHideFieldPattern, updateFieldConditionPattern, calcPattern, hideValuePattern, toggleRequiredPattern} from "@/utils/formBuilder/patterns";


export default {
  props: {
    schema: {
      type: Array,
      required: true
    },
    flatSchema: {
      type: Array,
      required: true
    },
    conditions: {
      type: Array,
      required: true
    },
    validationConditions: {
      type: Array,
      required: true
    },
    hideValues: {
      type: Array,
      required: true
    },
    calculations: {
      type: Array,
      required: true
    },
    updateConditions: {
      type: Array,
      required: true
    },
  },
  components: {
    ShowHideConditionConstructor,
    UpdateFieldConditionConstructor,
    Collapse,
  },
  setup() {
    const addItem = (list, pattern) => {
      list.push(cloneDeep(pattern))
    }
    const removeObj = (values, index) => {
      values.splice(index, 1);
    }

    return {
      addItem,
      removeObj,
      isFieldDateDisplayType,
      showHideFieldPattern,
      updateFieldConditionPattern,
      calcPattern,
      hideValuePattern,
      toggleRequiredPattern,
    }
  }
}

</script>


<style scoped lang="scss">
.list-group-item {
  cursor: pointer;
}
.add-cond {
  margin: 10px 0;
}
.section-title {
  margin-top: 2em;
  margin-bottom: 1em;
  padding-bottom: 5px;
  font-weight: bold;
  border-bottom: 1px #ddd solid;
}
.states {
  border: 1px solid #ddd;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// VueFormConditionsEditor.vue?8e22b22e